export default __webpack_public_path__ + "static/media/roboto-all-400-normal.376ea5d9.woff";